import { ref } from 'vue';

import Consts from '@/api/Consts';
import MapHelpers from '@/components/map/utils/MapHelpers';

const DEFAULT_GNSS_CODES = Consts.sortGnssCodes(['G', 'R', 'E', 'C', 'J']);

const useGnssOptions = (multiselectMode, initWithFirst, codes = DEFAULT_GNSS_CODES, defaultSelected = null) => {
	const gnssOptions = ref(Consts.sortGnssCodes(codes).map(value => ({
		value,
		label: MapHelpers.getGnssDataDisplay(value).name,
	})));
	const optionValues = gnssOptions.value.map(option => option.value);
	let initialValue;
	if (multiselectMode) {
		if (defaultSelected != null) {
			initialValue = Consts.sortGnssCodes(defaultSelected.filter(code => optionValues.includes(code)));
		} else {
			initialValue = initWithFirst ? [gnssOptions.value[0].value] : [];
		}
	} else {
		initialValue = initWithFirst ? gnssOptions.value[0].value : null;
	}
	const gnssSelected = ref(initialValue);
	const filterGnssOption = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	return {
		gnssOptions,
		gnssSelected,
		filterGnssOption,
	}
}

export {
	useGnssOptions,
}
